import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { createAuthSession } from '../lib/api';
import { useAuth } from '../context/AuthContext';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const redirectBack = () => {
      const dest = sessionStorage.getItem('post_login_redirect') || '/community';
      sessionStorage.removeItem('post_login_redirect');
      navigate(dest, { replace: true });
    };

    if (!sessionId) {
      navigate('/', { replace: true });
      return;
    }

    createAuthSession(sessionId)
      .then((u) => {
        setUser(u);
        // clean the hash
        window.history.replaceState(null, '', window.location.pathname);
        redirectBack();
      })
      .catch(() => navigate('/', { replace: true }));
  }, [navigate, setUser]);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-[#5B6472]">
      <div className="w-10 h-10 rounded-full border-2 border-[#2E6BFF] border-t-transparent animate-spin mb-4" />
      Signing you in...
    </div>
  );
}
